export default "__VITE_ASSET__Bn_xlhvL__"